export const PULLS_PATH = '/pulls'
export const PULLS_INBOX_PATH = '/pulls/inbox'
export const PULLS_SEARCH_PATH = '/pulls/search'
